// USA
export const locale = {
  lang: 'ar',
  data: {
    TRANSLATOR: {
      SELECT: 'أختر اللغة',
    },
    MENU: {
      DASHBOARD: 'الصفحة الرئيسية',
      ACCOUNTANTS: {
        ACCOUNTANTS: 'الحسابات',
        SYSTEM_MANAGER: 'إدارة النظام',
        JOURNAL_ENTRIES: 'القيود اليومية',
        SYSTEM_INFO: {
          ACCOUNT_GUIDE: 'دليل الحسابات',
          COST_PROFIT: 'مراكز التكلفة',
          ACCOUNT_PERIODS: 'الفترات الحسابية',
          CURRENCY: 'العملات',
          TAX: 'الضريبة',
          BRANCHES: 'الفروع',
        },
      },
    },
    AUTH: {
      GENERAL: {
        OR: 'أو',
        SUBMIT_BUTTON: 'موافق',
        NO_ACCOUNT: 'لا تمتلك حساب ؟',
        SIGNUP_BUTTON: 'التسجيل',
        FORGOT_BUTTON: 'تذكر كلمة السر',
        BACK_BUTTON: 'الرجوع',
        PRIVACY: 'الخصوصية',
        LEGAL: 'الامن',
        CONTACT: 'التواصل',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'تسجيل الدخول',
      },
      FORGOT: {
        TITLE: 'تذكر كلمة المرور ؟',
        DESC: 'ادخل البريد الالكتروني للاسترجاع',
        SUCCESS_MESSAGE:
          'الرجاء النقر على الرابط المرسل إلى بريدك الإلكتروني للتحقق من حسابك. شكرا لك',
        CHECK_EMAIL: 'تحقق من البريد الألكتروني',
        BACK_TO_HOME: 'الرجوع ألي الصفحة الرئيسية',
        MISS: 'لم يصلك رسالة ؟',
        RESEND: 'إرسال مره آخري',
      },
      REGISTER: {
        TITLE: 'تسجيل حساب',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'البريد الألكتروني',
        FULLNAME: 'الأسم بالكامل',
        PASSWORD: 'كلمة السر',
        CONFIRM_PASSWORD: 'تأكيد كلمة السر',
        USERNAME: 'الأسم المستعار',
      },
      VALIDATION: {
        INVALID: 'غير صحيح',
        REQUIRED: 'مطلوب',
        MIN_LENGTH: 'اقل عدد من الحروف',
        AGREEMENT_REQUIRED: 'يرجي قبول الشروط و الاحكام',
        NOT_FOUND: 'غير موجود',
        INVALID_LOGIN: 'بيانات غير صحيحة',
        REQUIRED_FIELD: 'مطلوب',
        MIN_LENGTH_FIELD: 'اقل حروف مطلوبة :',
        MAX_LENGTH_FIELD: 'أكثر حروف مطلوبة:',
        INVALID_FIELD: 'غير صحيح',
      },
    },
    BUTTONS: {
      EDIT: 'تعديل',
      ADD: 'اضافة',
      DELETE: 'مسح',
      SAVE: 'حفظ',
      CANCEL: 'الغاء',
      REPORT: 'تقرير',
      SUBMIT: 'إرسال',
      CHANGE_STATUS: 'تغير الحالة',
      VIEW: 'رؤية التفاصيل',
      DRAFT_POST: 'تعليق المنشور',
      SCHEDULE_DATEL: 'ترتيب الموعد',
      change_status: 'تغير الحالة',
      VIEW_CUSTOMER: 'رؤية تفاصيل عن العميل',
      NOTIFY: 'إشعار',
      DOWNLOAD: 'تحميل',
    },
    FOOTER: {
      about: 'حول',
      terms_and_conditions: 'قوانين الخدمة',
      privacy: 'خصوصية الخدمة',
      cookie_policty: 'ملف تعريف الارتياط',
      markting: 'التسويق',
    },
    VALIDATION: {
      required: 'مطلوب',
      maxLength: 'أقصي عدد من الحروف:',
      minLength: 'أقل عدد من الحروف:',
      email: 'غير صحيح',
      min: 'أقل مطلوب هو ',
      max: 'أقصي مطلوب هو ',
    },
    SIDE_MENU: {
      dashboard: 'الصفحة الرئيسية',
      statistics: 'التقارير',
      pending_reservation: 'حجوزات قيد التنفيذ',
      today_reservation: 'حجوزات اليوم',
      reservations: 'الحجوزات',
      all_reservations: 'جميع الحجوزات ',
      users_reviews: 'تقيم الزوار',
      services: 'الخدمات',
      gallery: 'معرض الصور',
      banners: 'لافتات',
      posts: 'المنشورات',
      create_new_post: 'إنشاء منشور جديد',
      manage_posts: 'إدارة المنشورات',
      manage_comments: 'إدارة التعليقات',
      loyalty: 'نظام النقاط',
      offers: 'العروض و البكدجات',
      new_offer: 'اضافة عرض جديد',
      manage_offers: 'إدارة العروض',
      admins: 'المشرفين',
      manage_admins: 'إدارة المشرفين',
      manage_roles: 'إدارة القواعد',
      users: 'المستخدمين',
      news_letter: 'الاشتراكات',
      contact: 'رسائل حصرية',
      notifications: 'الأشعارات',
      invoices: 'الفواتير',
      manage_working_times: 'إدارة أوقات العمل',
    },
    TABLE: {
      search: 'بحث',
      search_admins: 'بحث المشرفين',
      show_admins_only: 'رؤية المشرف النشاط فقط',
      list_of_admins: 'قائمة المشرفين',
      actions: 'العمليات',
      active: 'نشط',
      disabled: 'معطل',
      per_page: 'لكل صفحة',
      show_page: 'عرض ',
      list_of_roles: 'قائمة القواعد',
      search_roles: 'بحث القواعد',
      search_users: 'بحث المستخدمين',
      show_active_users: 'عرض المستخدمين النشطين فقط',
      list_of_users: 'قائمة المستخدمين',
      show_users_only: 'عرض المستخدمين النشاط فقط',
    },
    ADMIN_TABLE: {
      add_new_admin: 'أضافة مدير جديد',
      manage_admins: 'إدارة المشرفين',
      manage_roles: 'إدارة القواعد',
      COLUMNS: {
        name: 'الأسم',
        email: 'البريد الألكتروني',
        phone: 'رقم الهاتف',
        role: 'الوظيفة',
        status: 'الحالة',
        name_ar: 'الاسم العربي',
      },
      disbale_alert: 'تحذير التعطيل',
      alert_message: 'انت علي وشك تعطيل',
      keep_account: 'الحفاظ علي الحساب نشط',
      disable_account: 'تعطيل الحساب',
      new_admin: 'مدير جديد',
      edit_admin: 'تعديل المدير',
      name: 'الأسم',
      email: 'البريد الألكتروني',
      phone: ' رقم الهاتف',
      role: 'الوظيفة',
      password: 'كلمة السر',
      name_placeholder: 'الأسم الأول و الأخير ...',
      email_placeholder: 'البريد الألكتروني',
      generate_password: 'إنشاء كلمة السر',
      save_changes: 'حفظ التغييرات',
      delete_alert: 'تحذير الحذف',
      delete_message: 'هل انت متأكد من حذف ؟',
    },
    ROLES_TABLE: {
      add_new_role: 'أضافة وظيفة جديدة',
      manage_admins: 'إدارة المشرفين',
      manage_roles: 'إدارة القواعد',
      COLUMNS: {
        role: 'الوظيفة',
      },
      create_role: 'إنشاء وظيفة',
      update_role: 'تحديث الوظيفة',
      pick_the_permission: 'أختر الصلاحية',
      search_permission: 'بحث الصلاحية',
      role_name: 'أسم الوظيفة',
      role_name_ar: 'أسم الوظيفة بالعربي',
      create_new_role: 'إنشاء وظيفة جديدة',
      search: 'بحث',
      select_one_of_premade_roles: 'اختيار من الوظائف القائمة',
    },
    USERS_TABLE: {
      manage_users: 'إدارة المستخدمين',
      COLUMNS: {
        user_id: 'رقم المستخدم',
        name: 'الأسم',
        gender: 'النوع',
        phone: 'رقم الهاتف',
        email: 'البريد الألكتروني',
      },
    },
    POSTS_TABLE: {
      manage_posts: 'إدارة المنشورات',
      list_of_posts: 'قائمة المنشورات',
      search_posts: 'بحث عن منشور',
      search_by_date: 'بحث بالتاريخ',
      add_new_post: 'أضافة منشور جديد',
      update_post: 'تعديل المنشور',
      publish_post: 'نشر',
      Schedule_post: 'ترتيب المنشور',
      draft_post: 'أرشفةالمنشور',
      COLUMNS: {
        post_title: 'اسم المنشور',
        post_content: 'مضمون المنشور',
        created_by: 'تم إنشاؤه بواسطة',
        status: 'الحالة',
      },
      post_title: 'عنوان المنشور',
      post_text: 'محتوي المنشور',
      upload_media: 'رفع الصور',
    },
    BANNERS_TABLE: {
      banner: 'اللافتات',
      manage_banner: 'إدارة اللافتات',
      COLUMNS: {
        status: 'الحالة',
        banner_title: 'أسم اللافتة',
      },
      show_active: 'رؤية اللافتات النشطة',
      search_banner: 'بحث',
      list_of_banners: 'قائمة اللافتات',
      disbale_alert: 'تحذير غلق',
      alert_message: 'هل أنت متأكد من الغلق',
      keep_account: 'أبقاء نشط',
      disable_account: 'غلق اللافتة',
      create_banner: 'إنشاء لافتة',
      edit_banner: 'تعديل لافتة',
      delete_alert: 'تحذير حذف',
      delete_message: 'هل أنت متأكد من الحذف',
    },
    GALLERY_TABLE: {
      gallery: 'المعرض',
      manage_gallery: 'إدارة المعرض',
      COLUMNS: {
        status: 'الحالة',
        gallery_title: 'أسم المعرض',
        forward_url: 'رابط التوجيه',
      },
      show_active: 'رؤية صور المعرض النشطة',
      search_gallery: 'بحث',
      list_of_gallery: 'قائمة الصور',
      disbale_alert: 'تحذير غلق',
      alert_message: 'هل أنت متأكد من الغلق',
      keep_account: 'أبقاء نشط',
      disable_account: 'غلق الصورة',
      create_gallery: 'إنشاء صورة معرض',
      edit_gallery: 'تعديل صورة المعرض',
      delete_alert: 'تحذير حذف',
      delete_message: 'هل أنت متأكد من الحذف',
    },
    SERVICES_TABLE: {
      services: 'الخدمات',
      manage_services: 'إدارة الخدامات',
      COLUMNS: {
        status: 'الحالة',
        service_name: 'أسم الخدمة',
        service_description: 'وصف الخدمة',
        service_parent_name: 'أسم الخدمة الرئيسية',
      },
      show_active: 'رؤية الخدمات النشطة',
      search_service: 'بحث',
      list_of_service: 'قائمة الخدمات',
      disbale_alert: 'إنذار تعطيل',
      alert_message: 'هل انت متأكد من الغاء نشاط',
      keep_account: 'المتابعة في النشاط',
      disable_account: 'تعطيل الخدمة',
      create_service: 'إنشاء خدمة',
      edit_service: 'تعديل خدمة',
      delete_alert: 'إنذار حذف',
      delete_message: 'هل أنت متأكد من حذف',
      service_name_en: 'أسم الخدمة (بالأنجليزية)',
      service_name_ar: 'أسم الخدمة (بالعربية)',
      service_desc_en: 'وصف الخدمة (بالأنجليزية)',
      service_desc_ar: 'وصف الخدمة (بالعربية)',
      make_service_package: 'أجعل هذه الخدمة حزمة ؟',
      show_service_list: 'إظهار هذه الخدمة على القائمة الرئيسية؟',
      service_is_package: 'هذه الخدمة عبارة عن حزمة',
      service_is_list: 'هذه الخدمة رئيسية',
      select_parent_service: 'تحديد الخدمة الرئيسية',
      add_new_service: 'أضافة خدمة جديدة',
    },
    NEWS_LETTER: {
      newsletter: 'الاشتراكات',
      manage_newsletter: 'إدارة الاشتراكات',
      COLUMNS: {
        email: 'البريد الألكتروني',
        phone: 'رقم الهاتف',
      },
      search_newsletter: 'بحث',
    },
    CONTACT: {
      contact: 'رسائل حصرية',
      manage_contact: 'إدارة الرسائل الحصرية',
      COLUMNS: {
        email: 'البريد الإلكتروني',
        date: 'التاريخ',
        name: 'الأسم',
        message: 'الرسالة',
      },
      search_contact: 'بحث',
      message_details: 'تفاصيل الرسالة',
    },
    RESERVATION_TABLE: {
      reservations: 'الحجوزات',
      manage_reservation: 'إدارة الحجوزات',
      all_reservation: 'جميع الحجوزات',
      COLUMNS: {
        patient_name: 'أسم المريض',
        patient_mobile: 'هاتف المريض',
        reservation_date: 'تاريخ الحجز',
        service: 'الخدمة',
        status: 'الحالة',
        diagnostic: 'التشخيص',
        image_title: 'أسم الصورة',
      },
      search_reservation: 'بحث',
      search_date: 'بحث بواسطة التاريخ',
      search_status: 'بحث بواسطة الحالة',
      manage_working_times: 'إدارة المواعيد',
      add_new_reservtion: 'أضافة حجز جديد',
      daily_warp_up: 'غلق اليوم',
      there_are: 'هناك',
      pending_body: 'الحجوزات قيد الانتظار سوف يتم غلقهم',
      todays_reservations: 'حجوزات اليوم',
      total_reservations: 'جميع الحجوزات',
      pending_reservations: 'حجز قيد التنفيذ',
      confirmed_reservations: 'حجز مكتمل',
      canceled_reservations: 'حجز ملغي',
      users_reservations: 'حجوزات المريض',
      list_of_images: 'قائمة الصور',
      cancel_pending_and_close: 'غلق جميع الحجوزات قيد الانتظار',
      changeStatus: 'تغير الحالة',
      changeDate: 'تغير الحجز',
      choose_status: 'تغير الحالة',
      pick_time: 'أختيار الوقت و التاريخ',
      select_parent_service: 'أختر المريض',
      select_services: 'أختر الخدمة',
      list_of_Files: ' قائمة الملفات',
    },
    RESERVATION_DETAILS: {
      reservation_details: 'تفاصيل الحجز',
      reservation: 'الحجز',
      reschedule: 'ترتيب موعد الحجز',
      profile_history: 'إظهار تاريخ الملف الشخصي',
      personal_info: 'بيانات شخصية',
      photo: 'الصورة',
      name: 'الأسم',
      email: 'البريد الألكتروني',
      birthday: 'تاريخ الميلاد',
      mobile: 'رقم الجوال',
      gender: 'الجنس',
      city: 'المدينة',
      service_details: 'تفاصيل الخدمة',
      services: 'الخدمات',
      status: 'الحالة',
      reservation_date: 'تاريخ الحجز',
      add_new_service: 'أضافة خدمة جديدة',
      metrics_title: 'نموذج مقاييس الصحة والأمراض المزمنة',
      add_metrics: 'أضافة مقاييس جديدة',
      height: 'الطول',
      weight: 'العرض',
      d_history: 'تاريخ الأمراض',
      prev_procedure: 'الإجراء السابق',
      save_change: 'حفظ التغيرات',
    },
    COMMON: {
      type: 'أكتب هنا',
    },
    IMAGELIST: {
      create_image: 'إنشاء صورة',
      edit_image: 'تعديل صورة',
      image_title: 'عنوان الصورة',
      edit_file: 'تعديل الملف',
      file_title: 'أسم الملف',
      create_file: 'إنشاء ملف',
    },
    MANAGE_WORKING_TIMES: {
      manage_working_times: 'إدارة المواعيد',
      shifts: 'المناوبات',
      open_at: 'تفتح في',
      close_at: 'تغلق في',
      add_working_hour: 'إضافة موعد جديد',
      saturday: 'السبت',
      sunday: 'الأحد',
      monday: 'الأثنين',
      tuseday: 'الثلاثاء',
      wednesday: 'الأربعاء',
      thursday: 'الخميس',
      friday: 'الجمعة',
      no_times_yet: 'لا يوجد مواعيد حتي الآن',
      exception_working_days: 'أيام العمل الاستثنائية',
      exception_days_subtitle: 'الأيام التي ستكون فيها العيادة غير متاحة، ولن يسمح النظام بجدولة المواعيد في هذه التواريخ.',
      add_exception_day: 'إضافة يوم استثنائي',
      no_exception_days_yet: 'لا توجد أيام استثنائية حتى الآن.',
    },
    EXCEPTION_WORKING_DAYS_TABLE: {
      title: 'العنوان',
      date_from: 'من تاريخ ',
      date:'التاريخ',
      date_to: 'إلى تاريخ',
      off_hours: 'ساعات الإغلاق',
      time_from: 'من وقت',
      time_to: 'إلى وقت',
      is_all_day: 'طوال اليوم',
      is_recurring_yearly: 'متكرر سنوياً',
      actions: 'الإجراءات',
      search_exception_days: 'البحث في الأيام الاستثنائية',
      add_new_exception: 'إضافة استثناء جديد',
      edit_exception: 'تعديل الاستثناء',
      delete_exception: 'حذف الاستثناء',
      exception_title: 'عنوان الاستثناء',
      exception_title_placeholder: 'أدخل عنوان الاستثناء',
      save_exception: 'حفظ الاستثناء',
      cancel: 'إلغاء',
      validation_errors: {
        future_date: 'التاريخ يجب أن يكون في المستقبل',
        present_date: 'تاريخ اليوم يتطلب التحقق من صحة الوقت المحدد',
        date_range: 'تاريخ النهاية يجب أن يكون نفس تاريخ البداية أو بعده',
        time_range: 'وقت النهاية يجب أن يكون بعد وقت البداية',
        all_day_today: 'لا يمكن تعيين استثناءات لطوال اليوم لتاريخ اليوم',
        time_must_be_future: 'الوقت يجب أن يكون في المستقبل لتاريخ اليوم'
      }
    },
    REVIEWS_TABLE: {
      reviews: 'التقيمات',
      manage_reviews: 'إدارة التقيمات',
      COLUMNS: {
        patient_name: 'أسم المريض',
        note: 'ملاحظات',
        rating: 'التقييم',
        date: 'التاريخ',
      },
      search_review: 'بحث عن تقيم',
      date_search: 'بحث بالتاريخ',
      filter_rating: 'تصفية التقيمات',
      review_details: 'تفاصيل التقيم',
    },
    USERS_DETAILS: {
      user_details: 'تفاصيل المستخدم',
      loyalty_points: 'برنامج النقاط',
      personal_info: 'البيانات الشخصية',
      edit_loyalty: 'تعديل النقاط',
      increase_loyalty: 'زيادة النقاط',
      decrease_loyalty: 'تقليل النقاط',
      exp: 'تاريخ الأنتهاء : ',
      reason: 'السبب',
    },
    Metrics_TABLE: {
      metrics: 'المقاييس',
      COLUMNS: {
        date: 'التاريخ',
        height: 'الطول',
        weight: 'الوزن',
        d_history: 'تاريخ الأمراض',
      },
    },
    NOTIFICATIONS_TABLE: {
      notifications: 'الأشعارات',
      notifications_list: 'قائمة الأشعارات',
      search_notifications: 'بحث عن إشعار',
      new_notification: 'أنشاء إشعار جديد',
      edit_notification: 'تعديل إشعار',
      title_en: 'أسم الإشعار (بالأنجليزية)',
      title_ar: 'أسم الإشعار (بالعربية)',
      content_en: 'أشعار المحتوي (بالأنجليزية)',
      content_ar: 'أشعار المحتوي (بالعربية)',
      isFutureDate: 'تاريخ مستقبلي',
      resend_notify: 'إعادة إرسال الإشعار',
      resend_notify_message: 'هل أنت متأكد من إعادة إرسال الإشعار؟',
      COLUMNS: {
        date: 'التاريخ',
        title: 'العنوان',
        content: 'المحتوي',
      },
    },
    LOYALTY_POINTS_SETTING: {
      loyalty_points_setting: 'إدارة نقاط الولاء',
      details: 'التفاصيل',
      point_criteria: 'معايير النقاط',
      point_per_riyal: 'نقاط لكل ريال',
      point_per_riyal_message:
        'أدخل عدد نقاط الولاء المطلوبة لاسترداد ريال واحد من الخصم. على سبيل المثال، إذا أدخلت {{points}}، فإن كل {{points}} نقطة تساوي ريالًا واحدًا من الخصم للعملاء. ستحدد هذه القيمة عدد النقاط المطلوبة لكل ريال من الخصم.',
      expire_date: 'تاريخ انتهاء صلاحية النقاط الجديدة (بالأيام)',
      choose_expire_date: 'اختر تاريخ انتهاء الصلاحية',
      expire_date_message:
        'يرجى العلم أن سياسة انتهاء الصلاحية الجديدة ستُطبق فقط على النقاط المكتسبة من الآن فصاعدًا. لن تتأثر النقاط الحالية بهذا التحديث. ستُطبق قواعد انتهاء الصلاحية المُحدثة فقط على النقاط الجديدة المكتسبة بعد هذا التغيير.',
      registrationPoints: 'نقاط التسجيل',
      registrationPoints_message:
        'سيؤدي تعيين {{points}} نقاط إلى منح المستخدم الجديد خصمًا قدره ({{amount}}) ريال',
      reviewPoints: 'نقاط المراجعة',
      reviewPoints_message:
        'سيؤدي تحديد {{points}} نقاط إلى منح كل مراجعة خصمًا قدره ({{amount}}) ريال',
      sharePointsPercentage_message:
        'يُحدد هذا الحد الأقصى لنسبة النقاط التي يُمكن للمستخدم مشاركتها. ستحتفظ النقاط المُشاركة بتاريخ انتهاء صلاحيتها الأصلي.',
      invoiceRedeemPercentage: 'نسبة استرداد الفاتورة',
      invoiceRedeemPercentage_message:
        'إذا قمت بتعيينها على 5%، مقابل كل 1000 ريال يتم إنفاقها، يحصل العميل على X نقاط. هذا للحجوزات الجديدة بعد التغيير.',
      sharePointsPercentage: 'نسبة النقاط المتشاركة',
      maxSharePoints: 'أقصي عدد للنقاط المتشاركة',
      maxSahrePoints_message:
        'يُحدد هذا الحد الأقصى لعدد النقاط التي يُمكن للمستخدم مشاركتها. ستحتفظ النقاط المُشاركة بتاريخ انتهاء صلاحيتها الأصلي.',
      terms_header: 'شروط وأحكام برنامج نقاط الولاء',
      terms_en: 'النص الإنجليزي',
      terms_ar: 'النص العربي',
    },
    INVOICES_TABLE: {
      invoices: 'الفواتير',
      manage_invoices: 'إدارة الفواتير',
      COLUMNS: {
        id: 'رقم الفاتورة',
        date: 'تاريخ الفاتورة',
        patient_name: 'أسم المريض',
        patient_phone: 'هاتف المريض',
        total_price: 'الإجمالي',
        status: 'الحالة',
      },
      all_invoices: 'جميع الفواتير',
      search_invoices: 'بحث فاتورة',
      search_by_date: 'بحث بالتاريخ',
      create_new_invoice: 'إنشاء فاتورة جديدة',
      amount: 'السعر',
      invoice_details: 'تفاصيل الفاتورة',
      print_invoice: 'طباعة الفاتورة',
      billed_to: 'العميل',
      invoice_number: 'رقم الفاتورة',
      invoice_date: 'تاريخ الفاتورة',
      reservation_id: 'رقم الحجز',
      invoice_sar: 'سعر الفاتورة',
      services: 'الخدمات',
      sub_total: 'المجموع الفرعي قبل الخصم',
      discount: 'الخصم',
      total: 'الإجمالي',
      select_reservation: 'أختر الحجز',
      add_discount: 'أضافة خصم',
      currancy: 'ريال',
      user_invoices: 'فواتير العميل',
    },
    DASHBOARD: {
      total_visits: 'عدد الزيارات',
      total_compeleted_visits: 'الزيارات المكتملة',
      total_cancel_visits: 'الزيارات الملغاة',
      total_opening_visits: 'الزيارات المفتوحة',
      yearly: 'سنوي',
      daily: 'يومي',
      quarterly: 'ربع سنه',
      monthly: 'شهري',
      chart_reports: 'التقارير',
    },
  },
};
